module.exports = __webpack_public_path__ + "static/media/difficulty1.c767c42f.png";